module.exports = __webpack_public_path__ + "img/07.a16ef74f.jpg";